import principal from "../../assets/PrincipalPhoto.jpg";

const PrincipalDesk = () => {
    return (
        <div id="principal" className="about-message container">
            <div className="message-left">
                <img src={principal} alt="Principal" />
            </div>

            <div className="message-right">
                <h2>Principal's Desk</h2>
                <h4>A Message from the Principal</h4><br />
                <p>
                    It is my great pleasure to welcome you to Nav Jeevan Mission School, Anandnagar.
                </p><br />
                <p>
                    At Nav Jeevan Mission School, we believe that education is a journey of discovering one’s potential, developing character and preparing young minds to become responsible and compassionate citizens. Our goal is to provide every student with a positive, safe and stimulating environment where learning becomes meaningful and enjoyable.
                </p>
                <p>
                    We strive for academic excellence along with character formation, discipline, creativity, leadership and holistic development. Through innovative teaching practices, co-curricular activities, sports and technology-enabled learning, we encourage our students to think independently, explore their talents and face the challenges of the future with confidence.
                </p>
                <p>
                    Our dedicated teachers work tirelessly to understand the individual needs of every child and guide them towards their goals. We also believe that a strong partnership between school, parents and students is essential for the overall development and success of every learner.
                </p>
                <p>
                    As we move forward, we remain committed to creating an educational environment founded on knowledge, values, discipline, service and excellence.
                </p>
                <p>I warmly welcome you to our school community and look forward to working together for the bright future of our students.
                </p>
                <h4>With warm regards,<br />MR SHAJI LOUIS<br />
                    Principal
                    <br />
                    Nav Jeevan Mission School
                    Anandnagar
                </h4>
            </div>

        </div>
    );
};

export default PrincipalDesk;